import { useQuery } from 'react-query';
import { AxiosError } from 'axios';
import api from 'services';
import { ApiError } from 'services/api.errors';
import { PortfolioBalanceResponse } from 'services/requests';
import { useQueryParams } from 'hooks/routes';
import { QueryKeys } from 'constants/queryKeys';
import { Parameters } from 'constants/queryParameters';

export const useGetBalance = () => {
  const queryFn = (profileId: number | undefined) => async () => {
    const { data } = await api.getProfileBalance(profileId);
    return data;
  };

  const profileId =
    useQueryParams(Parameters.iraUserId) ??
    useQueryParams(Parameters.independentIraUserId);

  const queryKey = [QueryKeys.profileBalance, profileId];

  return useQuery<PortfolioBalanceResponse, AxiosError<ApiError>>(
    queryKey,
    queryFn(Number(profileId)),
    {
      enabled: !!profileId,
    },
  );
};
